import { Badge, Group, Loader, Tooltip } from '@mantine/core'
import { FormattedMessage } from 'react-intl'
import { CrossCameraPipelineStatus } from '@/types/crossCamera'

const SETTLING_STATUSES = [
  CrossCameraPipelineStatus.Pending,
  CrossCameraPipelineStatus.Starting
]

const STATUS_CONFIG: Record<
  CrossCameraPipelineStatus,
  { color: string; translationId: string }
> = {
  [CrossCameraPipelineStatus.Pending]: {
    color: 'gray',
    translationId: 'crossCamera.pipelines.status.pending'
  },
  [CrossCameraPipelineStatus.Starting]: {
    color: 'blue',
    translationId: 'crossCamera.pipelines.status.starting'
  },
  [CrossCameraPipelineStatus.Running]: {
    color: 'green',
    translationId: 'crossCamera.pipelines.status.running'
  },
  [CrossCameraPipelineStatus.Degraded]: {
    color: 'orange',
    translationId: 'crossCamera.pipelines.status.degraded'
  },
  [CrossCameraPipelineStatus.Stopped]: {
    color: 'gray',
    translationId: 'crossCamera.pipelines.status.stopped'
  },
  [CrossCameraPipelineStatus.Failed]: {
    color: 'red',
    translationId: 'crossCamera.pipelines.status.failed'
  }
}

type CrossCameraPipelineStatusBadgeProps = {
  status: CrossCameraPipelineStatus
  errorMessage?: string
}

export const CrossCameraPipelineStatusBadge = ({
  status,
  errorMessage
}: CrossCameraPipelineStatusBadgeProps) => {
  const config = STATUS_CONFIG[status]

  const badge = (
    <Badge size="sm" color={config.color} tt="none">
      <Group gap={4} wrap="nowrap">
        {SETTLING_STATUSES.includes(status) && (
          <Loader size={10} color="white" />
        )}
        <span>
          <FormattedMessage id={config.translationId} />
        </span>
      </Group>
    </Badge>
  )

  return errorMessage ? (
    <Tooltip label={errorMessage} w={280} multiline>
      {badge}
    </Tooltip>
  ) : (
    badge
  )
}
